import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './MinimalTab.styled';

const MinimalTab = (props) => {
  return (
    <Styled.MinimalTab active={props.active} onClick={props.onClick}>
      {props.active === false && props.badgeValue > 0 && (
        <Styled.BadgeIndicator>
          <Styled.BadgeNumber>{props.badgeValue}</Styled.BadgeNumber>
        </Styled.BadgeIndicator>
      )}
      <span>{props.title}</span>
      {props.active && <Styled.ActiveIndicator />}
    </Styled.MinimalTab>
  );
};

MinimalTab.propTypes = {
  active: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  badgeValue: PropTypes.number,
};

export default MinimalTab;
